<template>
  <!-- logo和导航图标 -->
  <div :class="{ fixed: flag }">
    <div class="header">
      <a @click="goHome">
        <img :src="logoImg" alt="" class="logo" />
      </a>

      <div
        @click="
          () => {
            flag = !flag;
            $emit('show-nav', flag);
          }
        "
      >
        <img v-if="flag" src="@/assets/image/close.png" alt="关闭" class="icon" />
        <img v-else src="@/assets/image/nav.png" alt="显示" class="icon" />
      </div>
    </div>

    <div v-show="flag" class="nav-ctn bg-white z-99">
      <!-- 搜索框 -->
      <van-search
        class="search"
        v-model="key"
        shape="round"
        clearable
        placeholder="请输入搜索内容"
        left-icon="null"
        right-icon="search"
        autofocus
        @click-right-icon="onSearch"
      />

      <!-- 导航 -->
      <ul class="nav-list">
        <li
          v-for="(menu, index) in firstMenusToShow.slice(0, -2)"
          :key="index"
          class="flex justify-between border-b py-32px"
          @click="clickFirstMenu(menu, clickTag)"
        >
          <span class="text-32px text-[#333333] leading-45px font-medium">{{ menu.name }}</span>
          <a>
            <van-icon name="arrow" color="#1989fa" size="28" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import logoImg from '../../static/image/logo.png';
import codes from '@/api/codes';
import { configureParams } from '@/assets/js/configureParams';
export default {
  name: 'Header',
  emits: ['show-nav'],
  data() {
    return {
      logoImg,
      key: '',
      flag: false,
      firstMenusToShow: [], // 一级栏目导航列表
      clickTag: codes.MENU, // 标记点击的是菜单
      onlineService: codes.ONLINE_SERVICE, // 在线服务模块
    };
  },
  computed: {},
  mounted() {
    this.initFirstLevelMenu();
  },
  methods: {
    init() {
      if (this.searchKey) {
        this.key = this.searchKey;
      } else {
        this.key = '';
      }
    },

    // 路由跳转首页
    jump() {
      this.$router.push('/home');
    },

    handleClick() {
      this.init();
    },

    // 链接跳转
    openUrl() {
      let url = 'https://www.jchc.cn/#/?plat=pc';
      window.open(url);
    },

    onSearch() {
      if (this.key) {
        let query = {
          searchKey: this.key,
        };
        this.$router.push({
          path: '/search',
          query,
        });
        this.show = false;
        this.btnName = 'search';
      } else {
        this.error = true;
        this.btnName = 'cross';
      }
    },

    // 获取一级栏目导航
    initFirstLevelMenu() {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
      };
      this.$api.getFirstLevelMenu(replacement).then((data) => {
        this.firstMenusToShow = data;
      });
    },

    // 点击一级菜单
    clickFirstMenu(menuData, clickTag) {
      this.flag = false;
      this.$emit('show-nav', this.flag);
      // 获取栏目的菜单结构(每层菜单中的第一个)
      let replacement = {
        subjectId: codes.SUBJECT_ID,
        menuId: menuData.id,
      };
      this.$api.getMenuLevels(replacement).then((data) => {
        this.$router.push({
          path: '/content',
          query: configureParams(data, menuData, clickTag),
        });
      });
    },

    goHome() {
      this.$router.push('/home');
    },

    goContact() {
      this.$router.push('/contact');
    },

    goOnline() {
      this.$router.push('/online');
    },
  },
};
</script>

<style scoped lang="scss">
// @import '@/assets/css/common.scss';

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 110px;
  padding: 0 45px 0 33px;

  img {
    vertical-align: middle;
  }

  .logo {
    width: 334px;
  }

  .icon {
    width: 32px;
    height: 32px;
  }
}

.fixed {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2022;
  background: #fff;
}

.nav-ctn {
  padding: 33px 44px 80px;
  .search {
    height: 74px;
  }
}

.nav-list {
  margin: 33px 0;
  font-size: 32px;
  font-weight: 500;
  color: #333333;
  line-height: 45px;
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 33px 15px;
    border-bottom: 1px solid #cbcccd;
  }
}

/deep/ .van-search {
  padding: 0;
}
/deep/ .van-field__left-icon {
  margin-right: 5px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue